import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import GiveThanksPage from './pages/GiveThanksPage';
import ReceiveThanksPage from './pages/ReceiveThanksPage';
import AboutPage from './pages/AboutPage';
import HowItWorksPage from './pages/HowItWorksPage';
import ContactPage from './pages/ContactPage';
import { initGA, trackPageView } from './utils/analytics';
import './styles/main.css';

// Component to track page views on route changes
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize Google Analytics on app mount
    initGA();
  }, []);

  return (
    <Router>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<GiveThanksPage />} />
        <Route path="/receive" element={<ReceiveThanksPage />} />
        <Route path="/receive-demo" element={<ReceiveThanksPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Company/team context routes */}
        <Route path="/:company" element={<GiveThanksPage />} />
        <Route path="/:company/receive" element={<ReceiveThanksPage />} />
      </Routes>
    </Router>
  );
};

export default App;
